import React, { Component } from 'react'
import { NumericFormat } from 'react-number-format';

class NumberFormatCustom extends Component {

    render() {
        const { inputRef, onChange, ...other } = this.props;
        return (
            <NumericFormat
                {...other}
                getInputRef={inputRef}
                onValueChange={values => {
                    onChange({
                        target: {
                            value: values.value,
                        },
                    });
                }}
            />
        )
    }
}

export default (NumberFormatCustom)
